import styled, { css } from 'styled-components';
import { getSizeStyles, SizeTypes } from '../sizes';

export const TextFieldContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

export const TextFieldLabel = styled.label<{ disabled?: boolean }>`
  color: ${({ theme, disabled }) =>
    disabled ? theme.palette.text.disabled : theme.palette.grey63};
  font-weight: 400;
  font-size: 0.8rem;
  margin-bottom: 4px;
`;

const getBaseInputStyles = (
  size: SizeTypes,
  theme: any,
  displayWithIcon: boolean,
  isError?: boolean,
  width?: string,
  variant?: 'white' | 'grey',
  isTextArea?: boolean
) => {
  const wd = width ? width : 'inherit';
  const bgColor =
    variant === 'grey'
      ? theme.palette.controls.grey.background
      : theme.palette.controls.light.background;
  const brd = isError ? `1px solid ${theme.palette.error}` : 'none';
  return css`
    width: ${wd};
    ${!isTextArea && getSizeStyles(size, displayWithIcon)};
    font-size: 1rem;
    background: ${bgColor};
    border: ${brd};
    border-radius: ${theme.borderRadius};
    &:focus {
      outline: none !important;
      border: 1px solid ${theme.palette.primaryBorderFocus};
    }
    &::placeholder {
      color: ${theme.palette.grey44};
    }
    &:disabled::placeholder {
      color: ${theme.palette.grey13};
    }
  `;
};

export const TextField = styled.input<{
  fieldSize: SizeTypes;
  isError?: boolean;
  width?: string;
  variant?: 'white' | 'grey';
  displayWithIcon: boolean;
  autoFocus?: string;
}>`
  ${({ fieldSize, isError, width, variant, theme, displayWithIcon }) =>
    getBaseInputStyles(
      fieldSize,
      theme,
      displayWithIcon,
      isError,
      width,
      variant
    )};
`;

export const TextArea = styled.textarea<{
  height: string;
  isError?: boolean;
  width?: string;
  variant?: 'white' | 'grey';
  displayWithIcon: boolean;
}>`
  ${({ isError, width, variant, theme, displayWithIcon }) =>
    getBaseInputStyles(
      'sm',
      theme,
      displayWithIcon,
      isError,
      width,
      variant,
      true
    )};
  resize: none;
  box-shadow: none;
  overflow: auto;
  height: ${({ height }) => height};
  padding: 10px;
`;

export const OptionalHelperText = styled.div<{ disabled?: boolean }>`
  color: ${({ theme, disabled }) =>
    disabled ? theme.palette.text.disabled : theme.palette.grey63};
  font-weight: 400;
  font-size: 0.8rem;
  margin-top: 4px;
  margin-left: 4px;
`;

export const TextFieldErrorMessage = styled.div`
  color: ${({ theme }) => theme.palette.error};
  font-weight: 400;
  font-size: 0.8rem;
  margin-top: 4px;
`;

export const TextFieldIconWrapper = styled.div`
  display: flex;
  align-items: center;
  border-radius: ${({ theme }) => theme.borderRadius};
`;

export const IconWrapper = styled.div`
  display: flex;
  align-items: center;
  padding: 8px;
  position: absolute;
  /* border-right: 1px solid red; */
`;
